// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@stoneage/Overrides/Widgets/Basic/LinkList";
import { fontConfig } from "@stoneage/XDL/constants";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

// <XNG changes>
linkListStyles.titleLink = {
    color: "white",
    typographyProps: {
        weight: fontConfig.weight.bold,
        ...fontConfig.regularSingleLine,
    },
};

linkListStyles.linkWrapper = {
    css: css`
        &,
        &:last-child {
            padding-top: 14px;
        }
        .list-link {
            font-size: ${fontConfig.xSmallSingleLine.size}px;
            line-height: ${fontConfig.xSmallSingleLine.lineHeight};
            font-weight: ${fontConfig.weight.medium};
            color: ${color("common.ui3")};
            &:hover,
            &:focus {
                color: ${color("primary.main")};
            }
            span {
                color: ${color("common.ui5")};
                font-weight: 300;
                &:hover {
                    color: ${color("common.white")};
                }
            }
        }
        &:empty {
            display: none;
        }
    `,
};

linkListStyles.titleWrapper = {
    css: css`
        ${({ showBorderUnderTitle }: any) =>
            showBorderUnderTitle &&
            css`
                border-bottom: 1px solid ${color("common.ui8")};
                padding-bottom: 12px;
            `}
    `,
};

linkListStyles.linkListWrapper = {};
